// ** React Imports
import { useCallback, useContext } from "react";

// ** Redux
import { useDispatch } from "react-redux";
import { getPosts } from "store/modules/main-pages/posts/get-posts.action";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardBodyItem } from "components/layout/Card/CardBodyItem";
import { CardTitle } from "components/layout/Card/CardTitle";
import { CardBody } from "components/layout/Card/CardBody";
import { CardFooter } from "components/layout/Card/CardFooter";
import LoadingContainer from "components/layout/LoadingContainer";
import ShowMoreLink from "components/layout/ShowMoreLink";
import Heading from "components/typography/HeadingLink";
import MediaPost from "components/user/MediaPosts/MediaPost";

// ** Utils & Helpers
import generatePath from "utils/generatePath";

// **Routes
import containers from "containers";

// ** Context
import AuthContext from "contexts/authContext";

// #####################################################
const Posts = ({ posts, loading, isReload, locationFull }) => {
	const { t } = useTranslation(["common", "pages"]);

	const dispatch = useDispatch();

	const isAuth = useContext(AuthContext);

	const to = generatePath(containers.posts.path);

	const renderPosts = useCallback(() => {
		return posts.map((item, index) => (
			<CardBodyItem key={item.id} $noPaddingTop={index === 0}>
				<MediaPost
					item={item}
					user={item}
					noPaddingAndMarginXInMobile
				/>
			</CardBodyItem>
		));
	}, [posts]);

	// #####################################################

	return (
		<CardWrapper>
			<CardTitle>
				<Heading
					noPadding
					to={to}
					type="h3"
					headerGrid={posts.length > 0 && !loading}
					onClick={() => {
						dispatch(
							getPosts({
								filters: {
									location: locationFull,
									period: {
										selectedDate: {
											year: new Date().getFullYear(),
											month: 0,
										},
										period: "latest",
									},
								},
								isAuth,
							})
						);
					}}
				>
					{t("pages:posts")}
				</Heading>
			</CardTitle>
			<CardBody>
				<LoadingContainer
					empty={posts.length === 0}
					noContentText={t("common:empty.postsList")}
					loading={loading || isReload}
					loaderDefault
				>
					{!loading && renderPosts()}
				</LoadingContainer>
			</CardBody>

			<CardFooter>
				<ShowMoreLink
					to={to}
					onClick={() => {
						dispatch(
							getPosts({
								filters: {
									location: locationFull,
								},
								isAuth,
							})
						);
					}}
				/>
			</CardFooter>
		</CardWrapper>
	);
};

// #####################################################

export default Posts;

// #####################################################
